import { fetchDelete, fetchGet, fetchPost, fetchPut } from './fetch';
import {
  AddNewFolderRequest,
  DeleteAudioToFolderRequest,
  DeleteAudioToFolderResponse,
  DeleteFolderRequest,
  DeleteFolderResponse,
  DownloadFolderRequest,
  DownloadFolderResponse,
  GetFolderListResponse,
  MoveAudioToFolderRequest,
  MoveAudioToFolderResponse,
  RenameFolderRequest,
  RenameFolderResponse,
  SetFolderSortRequest,
  SetFolderSortResponse,
} from './interface';

const API_URL = '';

export const getFolderList = async (): Promise<GetFolderListResponse> => {
  const url = `${API_URL}/api/v1/folder/list`;
  return fetchGet<GetFolderListResponse>(url);
};

export const AddNewFolder = async (req: AddNewFolderRequest): Promise<GetFolderListResponse> => {
  const url = `${API_URL}/api/v1/folder/add_new_folder`;
  return fetchPost<AddNewFolderRequest, GetFolderListResponse>(url, req);
};

export const MoveAudioToFolder = async (req: MoveAudioToFolderRequest): Promise<MoveAudioToFolderResponse> => {
  const url = `${API_URL}/api/v1/folder/move_audio_to_folder`;
  return fetchPost<MoveAudioToFolderRequest, MoveAudioToFolderResponse>(url, req);
};

export const DeleteAudioToFolder = async (req: DeleteAudioToFolderRequest): Promise<DeleteAudioToFolderResponse> => {
  const url = `${API_URL}/api/v1/folder/delete_audio_to_folder`;
  return fetchDelete<DeleteAudioToFolderRequest, DeleteAudioToFolderResponse>(url, req);
};

export const RenameFolder = async (req: RenameFolderRequest): Promise<RenameFolderResponse> => {
  const url = `${API_URL}/api/v1/folder/rename_folder`;
  return fetchPut<RenameFolderRequest, RenameFolderResponse>(url, req);
};

export const SetFolderSort = async (req: SetFolderSortRequest): Promise<SetFolderSortResponse> => {
  const url = `${API_URL}/api/v1/folder/set_sort`;
  return fetchPut<SetFolderSortRequest, SetFolderSortResponse>(url, req);
};

export const DeleteFolder = async (req: DeleteFolderRequest): Promise<DeleteFolderResponse> => {
  const url = `${API_URL}/api/v1/folder/delete`;
  return fetchDelete<DeleteFolderRequest, DeleteFolderResponse>(url, req);
};

export const DownloadFolder = async (req: DownloadFolderRequest): Promise<DownloadFolderResponse> => {
  const url = `${API_URL}/api/v2/audio/download_folder/${req.folderId}`;
  return fetchGet<DownloadFolderResponse>(url);
};
